import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

export default function Processing({ steps, active, error, onRetry, onRestart }) {
  return (
    <div className="min-h-[100dvh] grid place-items-center bg-[var(--fs-page)] px-6">
      <div className="w-full max-w-sm text-center">
        {!error ? (
          <>
            <div className="relative w-24 h-24 mx-auto">
              <span className="absolute inset-0 rounded-full bg-[var(--fs-accent)]/25 fs-breathe" />
              <span className="absolute inset-3 rounded-full bg-[var(--fs-tint)]" />
              <span className="absolute inset-0 grid place-items-center">
                <span className="w-10 h-10 rounded-full border-2 border-[var(--fs-blue)] border-t-transparent animate-spin" />
              </span>
            </div>

            <div className="mt-9 space-y-3" data-testid="processing-steps">
              {steps.map((s, i) => (
                <motion.div
                  key={i}
                  animate={{ opacity: i <= active ? 1 : 0.4 }}
                  className="flex items-center justify-center gap-2 text-sm"
                >
                  <span
                    className={`w-2 h-2 rounded-full ${
                      i < active ? "bg-[var(--fs-blue)]" : i === active ? "bg-[var(--fs-accent)] fs-breathe" : "bg-slate-300"
                    }`}
                  />
                  <span className={i === active ? "text-[var(--fs-ink)] font-medium" : "text-[var(--fs-muted)]"}>{s}</span>
                </motion.div>
              ))}
            </div>
            <p className="mt-8 text-xs text-[var(--fs-muted)]">Un momento, stiamo lavorando con cura.</p>
          </>
        ) : (
          <div className="fs-card p-6" data-testid="processing-error">
            <span className="grid place-items-center w-12 h-12 rounded-2xl bg-amber-50 text-amber-600 mx-auto">
              <AlertTriangle size={22} />
            </span>
            <h2 className="text-lg font-semibold mt-4">Si è verificato un problema</h2>
            <p className="text-sm text-[var(--fs-ink-2)] mt-2">{error}</p>
            <div className="flex gap-3 mt-6">
              <button onClick={onRestart} className="fs-btn-ghost flex-1 py-3 fs-focus" data-testid="processing-restart-button">Ricomincia</button>
              {onRetry && (
                <button onClick={onRetry} className="fs-btn-primary flex-1 py-3 fs-focus" data-testid="processing-retry-button">Riprova</button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
